import type {ModalWindowBindings, ModalWindowResolveValues} from '../modals.types';
import type {Component} from 'typings/portaro.fe.types';
import KpPrintPageModal from './KpPrintPageModal.svelte';
import type {PrintPageResponse} from './types';

export class PrintPageModalComponent implements Component<ModalWindowBindings<PrintPageResponse>> {
    public static componentName = 'printPageModal';

    public bindings = {
        resolve: '<'
    } as const;
    public controller = PrintPageModalComponentController;
    public templateUrl = require('./print-page-modal.tpl.ftl');
}

class PrintPageModalComponentController implements ModalWindowBindings<PrintPageResponse> {
    public component = KpPrintPageModal;
    public resolve: ModalWindowResolveValues<PrintPageResponse>;
}